export default "__VITE_ASSET__bf836e68__"